import React from 'react';
import { Target, Layers, Zap, Aperture } from 'lucide-react';
import { valueProps } from '../data/mock';

const iconMap = {
  Target,
  Layers,
  Zap,
  Aperture,
};

const ValueSection = () => {
  return (
    <section data-testid="value-section" className="py-10 lg:py-16 relative">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="mb-8 lg:mb-12">
          <h2 className="text-2xl lg:text-4xl font-bold mb-4 text-white">
            Warum Brands mit Northlight arbeiten
          </h2>
          <div className="w-16 h-[2px] bg-[#ff84e4]/60" />
        </div>

        {/* Value Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {valueProps.map((prop) => {
            const IconComponent = iconMap[prop.icon];
            return (
              <div
                key={prop.id}
                data-testid={`value-card-${prop.id}`}
                className="group p-6 rounded-2xl bg-white/[0.02] border border-white/[0.06] transition-colors duration-200 hover:bg-white/[0.04] hover:border-white/[0.12]"
              >
                <div className="w-11 h-11 rounded-xl bg-[#ff84e4]/10 flex items-center justify-center mb-5 transition-transform duration-300 group-hover:scale-110">
                  <IconComponent className="w-5 h-5 text-[#ff84e4]" />
                </div>
                <h3 className="text-base font-semibold mb-2 text-white">
                  {prop.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">
                  {prop.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueSection;
